import { render, staticRenderFns } from "./Abonado.vue?vue&type=template&id=2415d65c"
import script from "./Abonado.vue?vue&type=script&lang=js"
export * from "./Abonado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/abonados/Abonado.vue
// module id = null
// module chunks = 